import { CatalogSectionSortCriterionEnum } from '../../../modules/catalogs/enums/catalogSectionSortCriterion.enum';
import { CatalogCardVariantKey } from '../../../modules/catalogs/products/v2/sizing/catalogCardColumns.types';
import {
  CatalogViewGroupBy,
  CatalogViewMode,
} from '../../../modules/catalogs/products/v2/view/catalogView.types';

type FilterValues = Array<string> | string;
export type DefaultFilters = Record<string, FilterValues>;
export enum FilterPreferenceRecognizedLists {
  ANALYTICS = 'analytics',
  REPORTS = 'reports',
  SALES_REPORTS = 'salesReports',
  INVOICING_REPORTS = 'invoicingReports',
  SALES_TARGETS_REPORTS = 'salesTargetsReports',
  SALES_REPORTS_PERIOD = 'salesReportsPeriod',
  INVOICING_REPORTS_PERIOD = 'invoicingReportsPeriod',
  SALES_TARGETS_REPORTS_PERIOD = 'salesTargetReportsPeriod',
  SALES_TARGETS = 'salesTargets',
  CASES = 'cases',
  ORDERS = 'orders',
  CUSTOMER_OBJECT_ORDERS = '7c1e9a42-3b6d-4f2a-9e5c-8a1d6b3f4c20',
  CUSTOMER_OBJECT_INVOICES = '9d3f2b18-7c4a-4e6d-b1f5-2a9c8e7d3b40',
  CUSTOMER_OBJECT_ACCOUNTS = '4b8e1c5a-2d7f-4a3b-9c6e-1f0d5a8b7c30',
  CUSTOMER_OBJECT_ACTIVITIES = '6f2a9d34-8b1e-4c7a-a3d5-7e4b2c9f1a50',
  ORDER_OBJECT_ACTIVITIES = '1a5c7e93-4d2b-4f8a-b6c1-3e9d8a2f5b70',
  TARGET_OBJECT_ACTIVITIES = 'b1c314f7-3174-45be-b45f-d51020f838b8',
  MY_NETWORK = 'ee5bd69e-de38-4c1c-a506-ed5afca588c5',
  SALES_OPPORTUNITIES = 'salesOpportunities',
  CUSTOMERS = 'customers',
  STORE_ORDERS = 'storeOrders',
  SELLOUT_SALES_REPORTS = 'selloutSalesReports',
  INVOICES = 'invoices',
  SUPPLIER_SALES_REPORTS = 'supplierSalesReports',
  KITS = 'kits',
  SKU_KITS = 'skuKits',
  PAYMENT_METHODS = 'paymentMethods',
  ACCOUNTS_RECEIVABLE_INSTALLMENTS = 'accountsReceivableInstallments',
  PRODUCT_CLASSIFICATIONS = 'productClassifications',
  PRODUCT_CLASSIFICATIONS_TYPES = 'productClassificationsTypes',
  CUSTOMER_CLASSIFICATIONS = 'customerClassifications',
  CUSTOMER_CLASSIFICATIONS_TYPES = 'customerClassificationsTypes',
  BUSINESS_POLICIES = 'businessPolicies',
  COMMERCIAL_POLICIES = 'commercialPolicies',
  DELIVERY_WINDOWS = 'deliveryWindows',
  COLLECTIONS = 'collections',
  SALES_REPRESENTATIVES = 'salesRepresentatives',
  CONSULTANTS = 'consultants',
  PRODUCTS = 'products',
  GRIDS = 'grids',
  COLORS = 'colors',
  IMPORTS = 'imports',
  CUSTOMER_GROUPS = 'customerGroups',
  PRICE_TABLES = 'priceTables',
  PRODUCT_MATCH = 'productMatch',
  PRODUCT_REGISTRATION = 'productRegistration',
  MERCADOLOGICAL_TREE = 'mercadologicalTree',
  SETTINGS_READY_FOR_DELIVERY_STOCK = 'settingsReadyForDeliveryStock',
  SETTINGS_PACKS = 'settingsPacks',
  SETTINGS_FUTURE_STOCK = 'settingsFutureStock',
  SETTINGS_PRE_ORDER = 'settingsPreOrderStock',
  SETTINGS_SKU = 'settingsSku',
  WEBHOOK_EVENTS = 'webhookEvents',
  CATALOGS = 'catalogs',
  CATALOG_PRODUCTS = 'catalogProducts',
  LOCALS = 'locals',
  SETTINGS_PROMOTIONS = 'settingsPromotions',
  SETTINGS_PROMOTIONS_SKUS = 'settingsPromotionsSkus',
  SETTINGS_RAW_MATERIALS = 'settingsRawMaterials',
  SETTINGS_MATERIAL_STOCK = 'settingsMaterialStock',
  SETTINGS_MATERIAL_CONSUMPTION = 'settingsMaterialConsumption',
  SETTINGS_MATERIAL_PRE_ORDER = 'settingsMaterialPreOrder',
  SETTINGS_PRICE_TABLES_SKUS = 'settingsPriceTablesSkus',
  SETTINGS_PROFILE_TEAMS = 'settingsProfileTeams',
  SETTINGS_USERS = 'settingsUsers',
  SETTINGS_REPORT_PERMISSIONS = 'settingsReportPermissions',
  TARGETS_SALES_REPRESENTATIVES = 'targetsSalesRepresentatives',
  TARGETS_CUSTOMERS = 'targetsCustomers',
  TARGETS_STORE = 'targetsStore',
  STORE_RECENT_BRANDS = 'storeRecentBrands',
  ADMIN_BRANDS = 'adminBrands',
  ADMIN_STORES = 'adminStores',
  ADMIN_USERS = 'adminUsers',
  ADMIN_TECEO_USERS = 'adminTeceoUsers',
}

export type DefaultColumns = string[];
export enum ColumnsPreferenceRecognizedLists {
  ANALYTICS = 'analytics',
  REPORTS = 'reports',
  REPORT_PERIOD = 'reportPeriod',
  REPORT_SALES_COLLECTION = 'reportSalesCollection',
  REPORT_CATEGORY_SALES = 'reportCategory',
  REPORT_SUBCATEGORY_SALES = 'reportSubcategory',
  SALES_REPORT_BY_PRODUCT_CLASSIFICATION = 'salesReportByProductClassification',
  REPORT_CUSTOMERS_SALES = 'reportCustomersSales',
  REPORT_ORDER_SALES = 'reportOrderSales',
  REPORT_ORDER_ITEMS_SALES = 'reportOrderItemsSales',
  REPORT_ORDERS_INCOME = 'reportOrdersIncome',
  REPORT_ORDER_ITEMS_INCOME = 'reportOrderItemsIncome',
  REPORT_PRODUCT_SALES = 'reportProductSales',
  REPORT_PRODUCT_COLOR_SALES = 'reportProductColorSales',
  REPORT_PRODUCT_COLOR_DELIVERY_WINDOW_SALES = 'reportProductColorDeliveryWindowSales',
  REPORT_REPRESENTATIVE_SALES = 'reportRepresentativeSales',
  REPORT_SALES_TARGETS = 'reportSalesTargets',
  REPORT_ORDER_INCOME_BY_CUSTOMER = 'reportOrderIncomeByCustomer',
  ORDERS = 'orders',
  INVOICES = 'invoices',
  SALES_OPPORTUNITIES = 'salesOpportunities',
  TARGETS_SALES_REPRESENTATIVES = 'targetsSalesRepresentatives',
  TARGETS_CUSTOMERS = 'targetsCustomers',
  TARGETS_STORE = 'targetsStore',
  ORDER_TARGETS = 'orderTargets',
  CUSTOMERS = 'customers',
  STORE_ORDERS = 'storeOrders',
  CASES = 'cases',
  REPORT_PRODUCT_SELLOUT_SALES = 'reportProductSelloutSales',
  REPORT_PRODUCT_COLOR_SELLOUT_SALES = 'reportProductColorSelloutSales',
  REPORT_PRODUCT_COLOR_DELIVERY_WINDOW_SELLOUT_SALES = 'reportProductColorDeliveryWindowSelloutSales',
  REPORT_PRODUCT_SELL_OUT = 'reportProductSelloutSales',
  REPORT_PRODUCT_COLOR_SELL_OUT = 'reportProductColorSelloutSales',
  REPORT_SUPPLIER_ORDER_SALES = 'reportSupplierOrderSales',
  REPORT_SUPPLIER_ORDER_ITEMS_SALES = 'reportSupplierOrderItemsSales',
  KITS = 'kits',
  LOCALS = 'locals',
  SKU_KITS = 'skuKits',
  SALES_TARGETS = 'salesTargets',
  PAYMENT_METHODS = 'paymentMethods',
  PAYMENT_GATEWAYS = 'paymentGateways',
  ACCOUNTS_RECEIVABLE_INSTALLMENTS = 'accountsReceivableInstallments',
  PRODUCT_CLASSIFICATIONS = 'productClassifications',
  PRODUCT_CLASSIFICATIONS_TYPES = 'productClassificationsTypes',
  CUSTOMER_CLASSIFICATIONS = 'customerClassifications',
  CUSTOMER_CLASSIFICATIONS_TYPES = 'customerClassificationsTypes',
  BUSINESS_POLICIES = 'businessPolicies',
  COMMERCIAL_POLICIES = 'commercialPolicies',
  COLLECTIONS = 'collections',
  DELIVERY_WINDOWS = 'deliveryWindows',
  SALES_REPRESENTATIVES = 'salesRepresentatives',
  CONSULTANTS = 'consultants',
  PRODUCTS = 'products',
  GRIDS = 'grids',
  COLORS = 'colors',
  IMPORTS = 'imports',
  CUSTOMER_GROUPS = 'customerGroups',
  PRICE_TABLES = 'priceTables',
  CATALOG_CUSTOMERS = 'catalogCustomers',
  CATALOG_SALES_REPRESENTATIVES = 'catalogSalesRepresentatives',
  CATALOG_CLASSIFICATION_PERMISSIONS = 'catalogClassificationPermissions',
  SETTINGS_READY_FOR_DELIVERY_STOCK = 'settingsReadyForDeliveryStock',
  SETTINGS_PACKS = 'settingsPacks',
  SETTINGS_FUTURE_STOCK = 'settingsFutureStock',
  SETTINGS_PRE_ORDER = 'settingsPreOrderStock',
  MERCADOLOGICAL_TREE = 'mercadologicalTree',
  SETTINGS_SKU = 'settingsSku',
  SETTINGS_PROMOTIONS = 'settingsPromotions',
  SETTINGS_PROMOTIONS_SKUS = 'settingsPromotionsSkus',
  SETTINGS_RAW_MATERIALS = 'settingsRawMaterials',
  SETTINGS_MATERIAL_STOCK = 'settingsMaterialStock',
  SETTINGS_MATERIAL_CONSUMPTION = 'settingsMaterialConsumption',
  SETTINGS_PRODUCT_MATERIAL_CONSUMPTION = 'settingsProductMaterialConsumption',
  SETTINGS_MATERIAL_PRE_ORDER = 'settingsMaterialPreOrder',
  SETTINGS_PRICE_TABLES_SKUS = 'settingsPriceTablesSkus',
  SETTINGS_PROFILE_TEAMS = 'settingsProfileTeams',
  SETTINGS_USERS = 'settingsUsers',
  SETTINGS_ADDRESSES = 'settingsAddresses',
  SETTINGS_REPORT_PERMISSIONS = 'settingsReportPermissions',
  CUSTOMER_GROUP_PAYMENT_METHODS = 'customerGroupPaymentMethods',
  ADMIN_BRANDS = 'adminBrands',
  ADMIN_STORES = 'adminStores',
  ADMIN_USERS = 'adminUsers',
  ADMIN_TECEO_USERS = 'adminTeceoUsers',
}

export enum ViewPreferenceRecognizedLists {
  CATALOG_PRODUCTS = 'catalogProducts',
}

export type CatalogViewPreferenceSortCriterion = CatalogSectionSortCriterionEnum;
export type CatalogViewPreferenceGroupBy = CatalogViewGroupBy;

export interface DefaultView {
  mode: CatalogViewMode;
  cardSize: CatalogCardVariantKey;
  sortCriterion?: CatalogViewPreferenceSortCriterion;
  sortTargetId?: string | null;
  groupBy?: CatalogViewPreferenceGroupBy;
  groupTargetId?: string | null;
}

export type UiPreferenceValue = Record<string, unknown>;

export enum UiPreferenceRecognizedKeys {
  CATALOG_VIEW = 'catalog_view',
  ADD_ORDER_PRODUCT_TOGGLE = 'add_order_product_toggle',
}

export interface UiPreference {
  key: UiPreferenceRecognizedKeys;
  value: UiPreferenceValue;
}

export interface UserContextPreferences {
  id: string;
  filterPreferences?: Array<{
    list: FilterPreferenceRecognizedLists;
    defaultFilters: DefaultFilters;
  }>;
  columnsPreferences?: Array<{
    list: ColumnsPreferenceRecognizedLists;
    defaultColumns: DefaultColumns;
  }>;
  uiPreferences?: Array<UiPreference>;
}

export interface UpdateOrCreateFilterPreferenceInput {
  list: FilterPreferenceRecognizedLists;
  defaultFilters: DefaultFilters;
}

export interface UpdateOrCreateColumnsPreferenceInput {
  list: ColumnsPreferenceRecognizedLists;
  defaultColumns: DefaultColumns;
}

export interface UpdateOrCreateUiPreferenceInput {
  key: UiPreferenceRecognizedKeys;
  value: UiPreferenceValue;
}

export interface UpdateOrCreateViewPreferenceInput {
  list: ViewPreferenceRecognizedLists;
  defaultView: DefaultView | null;
}

export interface PreservationRuleProps {
  field: keyof DefaultFilters;
  conditionValue: string;
  dependentFields?: string[];
}
